var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15L11.0962 11.0962M12.7788 6.88942C12.7788 7.66283 12.6265 8.42867 12.3305 9.14321C12.0346 9.85775 11.6008 10.507 11.0539 11.0539C10.507 11.6008 9.85775 12.0346 9.14321 12.3305C8.42867 12.6265 7.66283 12.7788 6.88942 12.7788C6.11601 12.7788 5.35018 12.6265 4.63564 12.3305C3.9211 12.0346 3.27186 11.6008 2.72497 11.0539C2.17809 10.507 1.74428 9.85775 1.44831 9.14321C1.15233 8.42867 1 7.66283 1 6.88942C1 5.32745 1.62049 3.82945 2.72497 2.72497C3.82945 1.62049 5.32745 1 6.88942 1C8.45139 1 9.94939 1.62049 11.0539 2.72497C12.1584 3.82945 12.7788 5.32745 12.7788 6.88942Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMagnifyingGlass;